/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  changeQueryParams,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

import SortInputs from './SortInputs';
import ParamsTasksInputs from './ParamsTasksInputs';
import CostsRangeTaskInputs from './CostsRangeTaskInputs';
import TypesTasksInputs from './TypesTasksInputs';
import TaskOwnersInputs from './TaskOwnersInputs';
import TaskSearchInputs from './TaskSearchInputs';

// eslint-disable-next-line react/prefer-stateless-function
class TaskSearchForm extends Component {
  resetQueryParams = () => {
    this.props.changeQueryParams({});
    this.props.sendRequest();
  };

  render() {
    return (
      <div className="tab-content">
        <div className="tab-pane tabTasks active">
          <div
            className="panel-group panel-group-side "
            id="panelGroupFilter"
            role="tablist"
            aria-multiselectable="true"
          >
            {/* <SortInputs {...this.props} /> */}
            <TypesTasksInputs {...this.props} />
            <ParamsTasksInputs {...this.props} />
            <CostsRangeTaskInputs {...this.props} />
            {!this.props.isHideTaskOwnersInputs ? (
              <TaskOwnersInputs {...this.props} />
            ) : null}
            <TaskSearchInputs {...this.props} />
            <div className="border-t panel panel-default">
              <div className="panel-body">
                <button
                  className="btn btn-block btn-muted btn-sm"
                  title="Сбрость фильтры"
                  tabIndex="0"
                  onClick={() => {
                    this.resetQueryParams();
                  }}
                >
                  {t('Сбросить фильтры')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TaskSearchForm.defaultProps = {
  isHideTaskOwnersInputs: false
};

TaskSearchForm.propTypes = {
  // IN
  isHideTaskOwnersInputs: PropTypes.bool,
  // CONNECT
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    () => ({}),
    mapDispatchToProps
  )(TaskSearchForm)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/TaskSearchForm.js